/* tslint:disable */
/* eslint-disable */
/**
 * Knowspread API v1
 *  This document describes API of education system Knowspread. This API is used by AngularJS web application. ##Api path Api lives on path `./api/v1/{resource}` relative to the root of the deployed application. ##Api versioning This api is versioned to allow further updates that would break backward compatibility. Current version is `v1` and it will be finalized when the App is deployed into production. In every response with status code `2xx`, `400`, `401` or `403` is returned `X-API-Version` header with current api version. This value is for checking correct api version used in Android or iOS application. ## Request and Response format Both response and request bodies are of type `application/json` if not noted otherwise.  ## Authentication Client accessing Knowspread application authenticates itself with a `POST` request against endpoint `./api/v1/users/login` through invitation link or with username and password. If the user authentication is successful an user unique identificator `uid` is returned together with an `access-token`, `client` - type of client, which allows to be authenticated on more devices, and information about access token expiration. (Please see corresponding API spec for concrete JSON format of request and response)  Each API call of given client is then authenticated using the returned `access-token`,`client` and `uid` which is passed to the server in header. Server returns `401 - Unauthorized` if the given token is expired or not valid. In case of invalid token, client can request a new one by authenticating against `./api/v1/users/login` again. AccessToken validity is automatically prolonged by using it.  ## Error States  The common [HTTP Response Status Codes](https://github.com/for-GET/know-your-http-well/blob/master/status-codes.md) are used for signaling error states.  Error status codes are specified in first endpoint in API spec - `./api/v1/`.  ##Success code `200` status code is returned on success (it does not matter if it is a Create,Read,Delete or Update operation) ## Common patterns in KnowSpread API  All REST based resources in this follow these rules:  * CREATE (`POST`) - Returns status code `201 (OK)` when the creation of entity is successful. and contains dictionary representing the created entity, * READ (`GET`) - Returns status code `200 (OK)` and dictionary or array of dictionaries representing the entity requested. Dictionary with the same keys is expected by the server when updating the entity. * UPDATE (`PUT`) - Returns status code `200 (OK)` and dictionary that represents state of the entity after modification. * DELETE (`DELETE`) - Returns status code `204 (OK)` upon successful deletion of entity.  ## Date formatting API accepts and returns dates in ISO_8601. For more info see: http://en.wikipedia.org/wiki/ISO_8601 ## Documentation tags * PAGEABLE - this marks this request as pageable. If you want to iterate over pages, set query `\'page\' (integer)` to number requested page. You can set query `\'paginates_per\' (integer)`, what sets records count on one page. This request returns count of total pages, current page and total records count in header. * JOB PROCESSING always - where job scheduled always * JOB PROCESSING sometimes - where job scheduled sometimes * JOB PROCESSING callbacks - where shceduled any jobs to support main action of endpoint e.g. assign content to all users in group etc. 
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { ContentViewerTestDefinitionStepsMarkedAsCompleted } from './ContentViewerTestDefinitionStepsMarkedAsCompleted';
import {
    ContentViewerTestDefinitionStepsMarkedAsCompletedFromJSON,
    ContentViewerTestDefinitionStepsMarkedAsCompletedFromJSONTyped,
    ContentViewerTestDefinitionStepsMarkedAsCompletedToJSON,
} from './ContentViewerTestDefinitionStepsMarkedAsCompleted';
import type { ContentViewerTestDefinitionTestAttemptPayloadIndexResponseQuestionsInner } from './ContentViewerTestDefinitionTestAttemptPayloadIndexResponseQuestionsInner';
import {
    ContentViewerTestDefinitionTestAttemptPayloadIndexResponseQuestionsInnerFromJSON,
    ContentViewerTestDefinitionTestAttemptPayloadIndexResponseQuestionsInnerFromJSONTyped,
    ContentViewerTestDefinitionTestAttemptPayloadIndexResponseQuestionsInnerToJSON,
} from './ContentViewerTestDefinitionTestAttemptPayloadIndexResponseQuestionsInner';

/**
 * Content viewer test definition test attempt payload
 * @export
 * @interface ContentViewerTestDefinitionTestAttemptPayloadIndexResponse
 */
export interface ContentViewerTestDefinitionTestAttemptPayloadIndexResponse {
    /**
     * 
     * @type {number}
     * @memberof ContentViewerTestDefinitionTestAttemptPayloadIndexResponse
     */
    id: number;
    /**
     * 
     * @type {number}
     * @memberof ContentViewerTestDefinitionTestAttemptPayloadIndexResponse
     */
    achieved_points: number;
    /**
     * 
     * @type {string}
     * @memberof ContentViewerTestDefinitionTestAttemptPayloadIndexResponse
     */
    state: string;
    /**
     * 
     * @type {Date}
     * @memberof ContentViewerTestDefinitionTestAttemptPayloadIndexResponse
     */
    start_date: Date;
    /**
     * 
     * @type {Date}
     * @memberof ContentViewerTestDefinitionTestAttemptPayloadIndexResponse
     */
    end_date: Date;
    /**
     * 
     * @type {number}
     * @memberof ContentViewerTestDefinitionTestAttemptPayloadIndexResponse
     */
    content_participation_id: number;
    /**
     * 
     * @type {boolean}
     * @memberof ContentViewerTestDefinitionTestAttemptPayloadIndexResponse
     */
    is_completed: boolean;
    /**
     * 
     * @type {number}
     * @memberof ContentViewerTestDefinitionTestAttemptPayloadIndexResponse
     */
    remaining_time: number;
    /**
     * 
     * @type {string}
     * @memberof ContentViewerTestDefinitionTestAttemptPayloadIndexResponse
     */
    result: ContentViewerTestDefinitionTestAttemptPayloadIndexResponseResultEnum;
    /**
     * 
     * @type {number}
     * @memberof ContentViewerTestDefinitionTestAttemptPayloadIndexResponse
     */
    points_to_pass: number;
    /**
     * 
     * @type {number}
     * @memberof ContentViewerTestDefinitionTestAttemptPayloadIndexResponse
     */
    max_points: number;
    /**
     * 
     * @type {string}
     * @memberof ContentViewerTestDefinitionTestAttemptPayloadIndexResponse
     */
    show_answers_in_test_result: ContentViewerTestDefinitionTestAttemptPayloadIndexResponseShowAnswersInTestResultEnum;
    /**
     * 
     * @type {string}
     * @memberof ContentViewerTestDefinitionTestAttemptPayloadIndexResponse
     */
    test_type: string;
    /**
     * 
     * @type {Array<ContentViewerTestDefinitionStepsMarkedAsCompleted>}
     * @memberof ContentViewerTestDefinitionTestAttemptPayloadIndexResponse
     */
    steps_for_repeated_study?: Array<ContentViewerTestDefinitionStepsMarkedAsCompleted>;
    /**
     * 
     * @type {Array<ContentViewerTestDefinitionStepsMarkedAsCompleted>}
     * @memberof ContentViewerTestDefinitionTestAttemptPayloadIndexResponse
     */
    steps_marked_as_completed?: Array<ContentViewerTestDefinitionStepsMarkedAsCompleted>;
    /**
     * 
     * @type {boolean}
     * @memberof ContentViewerTestDefinitionTestAttemptPayloadIndexResponse
     */
    enforce_study_of_previous_steps: boolean;
    /**
     * 
     * @type {Array<ContentViewerTestDefinitionTestAttemptPayloadIndexResponseQuestionsInner>}
     * @memberof ContentViewerTestDefinitionTestAttemptPayloadIndexResponse
     */
    questions?: Array<ContentViewerTestDefinitionTestAttemptPayloadIndexResponseQuestionsInner>;
}


/**
 * @export
 */
export const ContentViewerTestDefinitionTestAttemptPayloadIndexResponseResultEnum = {
    Passed: 'passed',
    Failed: 'failed'
} as const;
export type ContentViewerTestDefinitionTestAttemptPayloadIndexResponseResultEnum = typeof ContentViewerTestDefinitionTestAttemptPayloadIndexResponseResultEnum[keyof typeof ContentViewerTestDefinitionTestAttemptPayloadIndexResponseResultEnum];

/**
 * @export
 */
export const ContentViewerTestDefinitionTestAttemptPayloadIndexResponseShowAnswersInTestResultEnum = {
    None: 'none',
    OnlyIncorrect: 'only_incorrect',
    All: 'all'
} as const;
export type ContentViewerTestDefinitionTestAttemptPayloadIndexResponseShowAnswersInTestResultEnum = typeof ContentViewerTestDefinitionTestAttemptPayloadIndexResponseShowAnswersInTestResultEnum[keyof typeof ContentViewerTestDefinitionTestAttemptPayloadIndexResponseShowAnswersInTestResultEnum];


/**
 * Check if a given object implements the ContentViewerTestDefinitionTestAttemptPayloadIndexResponse interface.
 */
export function instanceOfContentViewerTestDefinitionTestAttemptPayloadIndexResponse(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "id" in value;
    isInstance = isInstance && "achieved_points" in value;
    isInstance = isInstance && "state" in value;
    isInstance = isInstance && "start_date" in value;
    isInstance = isInstance && "end_date" in value;
    isInstance = isInstance && "content_participation_id" in value;
    isInstance = isInstance && "is_completed" in value;
    isInstance = isInstance && "remaining_time" in value;
    isInstance = isInstance && "result" in value;
    isInstance = isInstance && "points_to_pass" in value;
    isInstance = isInstance && "max_points" in value;
    isInstance = isInstance && "show_answers_in_test_result" in value;
    isInstance = isInstance && "test_type" in value;
    isInstance = isInstance && "enforce_study_of_previous_steps" in value;

    return isInstance;
}

export function ContentViewerTestDefinitionTestAttemptPayloadIndexResponseFromJSON(json: any): ContentViewerTestDefinitionTestAttemptPayloadIndexResponse {
    return ContentViewerTestDefinitionTestAttemptPayloadIndexResponseFromJSONTyped(json, false);
}

export function ContentViewerTestDefinitionTestAttemptPayloadIndexResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ContentViewerTestDefinitionTestAttemptPayloadIndexResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'achieved_points': json['achieved_points'],
        'state': json['state'],
        'start_date': (new Date(json['start_date'])),
        'end_date': (new Date(json['end_date'])),
        'content_participation_id': json['content_participation_id'],
        'is_completed': json['is_completed'],
        'remaining_time': json['remaining_time'],
        'result': json['result'],
        'points_to_pass': json['points_to_pass'],
        'max_points': json['max_points'],
        'show_answers_in_test_result': json['show_answers_in_test_result'],
        'test_type': json['test_type'],
        'steps_for_repeated_study': !exists(json, 'steps_for_repeated_study') ? undefined : ((json['steps_for_repeated_study'] as Array<any>).map(ContentViewerTestDefinitionStepsMarkedAsCompletedFromJSON)),
        'steps_marked_as_completed': !exists(json, 'steps_marked_as_completed') ? undefined : ((json['steps_marked_as_completed'] as Array<any>).map(ContentViewerTestDefinitionStepsMarkedAsCompletedFromJSON)),
        'enforce_study_of_previous_steps': json['enforce_study_of_previous_steps'],
        'questions': !exists(json, 'questions') ? undefined : ((json['questions'] as Array<any>).map(ContentViewerTestDefinitionTestAttemptPayloadIndexResponseQuestionsInnerFromJSON)),
    };
}

export function ContentViewerTestDefinitionTestAttemptPayloadIndexResponseToJSON(value?: ContentViewerTestDefinitionTestAttemptPayloadIndexResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'achieved_points': value.achieved_points,
        'state': value.state,
        'start_date': (value.start_date.toISOString()),
        'end_date': (value.end_date.toISOString()),
        'content_participation_id': value.content_participation_id,
        'is_completed': value.is_completed,
        'remaining_time': value.remaining_time,
        'result': value.result,
        'points_to_pass': value.points_to_pass,
        'max_points': value.max_points,
        'show_answers_in_test_result': value.show_answers_in_test_result,
        'test_type': value.test_type,
        'steps_for_repeated_study': value.steps_for_repeated_study === undefined ? undefined : ((value.steps_for_repeated_study as Array<any>).map(ContentViewerTestDefinitionStepsMarkedAsCompletedToJSON)),
        'steps_marked_as_completed': value.steps_marked_as_completed === undefined ? undefined : ((value.steps_marked_as_completed as Array<any>).map(ContentViewerTestDefinitionStepsMarkedAsCompletedToJSON)),
        'enforce_study_of_previous_steps': value.enforce_study_of_previous_steps,
        'questions': value.questions === undefined ? undefined : ((value.questions as Array<any>).map(ContentViewerTestDefinitionTestAttemptPayloadIndexResponseQuestionsInnerToJSON)),
    };
}

